import "leaflet/dist/leaflet.css";
import { useState, useEffect } from "react";
import "react-calendar/dist/Calendar.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../Appstore/store";
import { Line, Pie } from "react-chartjs-2";
import { ChartOptions } from "chart.js";
import {
  Chart as ChartJS, ArcElement, LineElement, CategoryScale, LinearScale, PointElement, Legend, Tooltip,
} from "chart.js";
import { Dropdown } from "react-bootstrap";
import HelpText from "./HelpText";
import CreatableSelect from "react-select";
import { GetallDashboard2Data } from "../Features/Dashboard/Dashboard2_0"
import {
  GetallSmsCampaign
} from "../Features/smscampaign/Smscampaign";
import { GetallSmtpCampaign } from "../Features/smtpcampaign/Smtpcampaign";
import { debounce } from "lodash";


// Chart Data Interface
interface ChartData {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    borderColor?: string;
    backgroundColor: string | string[];
    fill?: boolean;
    tension?: number;
    hoverBackgroundColor?: string[];
  }[];
}

interface OptionType {
  value: number;
  label: string;
}

ChartJS.register(
  LineElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip
);

function Home() {
  const dispatch = useDispatch<AppDispatch>();
  const [dateRangeText, setDateRangeText] = useState<string>("Date Filter");
  const [showSMSChart, setShowSMSChart] = useState<boolean>(true);
  const [showSMTPChart, setShowSMTPChart] = useState<boolean>(true);
  const [selectedSMSOption, setSelectedSMSOption] = useState<OptionType | null>(null);
  const [selectedSMTPOption, setSelectedSMTPOption] = useState<OptionType | null>(null);

  const [smscampaignOptions, setSmscampaignOptions] = useState<OptionType[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(5);
  const [search, setSearch] = useState<string>("");

  const [smtpcampaignOptions, setSmtpcampaignOptions] = useState<OptionType[]>([]);


  const { smscampaigndata, info } = useSelector(
    (state: RootState) => state.smscampaign
  );

  const { smtpcampaigndata } = useSelector(
    (state: RootState) => state.smtpcampaign
  );

  const { dashboarddata2, loading } = useSelector(
    (state: RootState) => state.dashboard2
  );

  const [pieChartData, setPieChartData] = useState<ChartData>({
    labels: [],
    datasets: [],
  });

  const [smtppieChartData, setsmtpPieChartData] = useState<ChartData>({
    labels: [],
    datasets: [],
  })

  const [smsChartData, setsmsChartData] = useState<{
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      borderColor: string;
      backgroundColor: string;
      fill: boolean;
      tension: number;
    }[];
  }>({
    labels: [],
    datasets: [],
  });

  const [smtpChartData, setsmtpChartData] = useState<{
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      borderColor: string;
      backgroundColor: string;
      fill: boolean;
      tension: number;
    }[];
  }>({
    labels: [],
    datasets: [],
  });


  useEffect(() => {
    dispatch(GetallDashboard2Data({
      from: "",
      to: "",
      campaign_type: "",
      campaign_id: null,
    }));
  }, [dispatch]);


  useEffect(() => {
    if (dashboarddata2?.pieChart) {
      const labels = dashboarddata2.pieChart.map((item) => item.label);
      const data = dashboarddata2.pieChart.map((item) => item.value);

      setPieChartData({
        labels,
        datasets: [
          {
            label: "SMS Stats",
            data,
            backgroundColor: [
              "#FF6384", // Red
              "#36A2EB", // Blue
              "#FFCE56", // Yellow
              "#4BC0C0", // Teal
            ],
            hoverBackgroundColor: [
              "#FF6384",
              "#36A2EB",
              "#FFCE56",
              "#4BC0C0",
            ],
          },
        ],
      });
    }
  }, [dashboarddata2]);

  useEffect(() => {
    if (dashboarddata2?.SMTPpieChart) {
      const labels = dashboarddata2.SMTPpieChart.map((item: any) => item.label);
      const data = dashboarddata2.SMTPpieChart.map((item: any) => item.value);

      setsmtpPieChartData({
        labels,
        datasets: [
          {
            label: "SMTP Stats",
            data,
            backgroundColor: [
              "#FF6384", // Red
              "#36A2EB", // Blue
              "#FFCE56", // Yellow
              "#4BC0C0", // Teal
            ],
            hoverBackgroundColor: [
              "#FF6384",
              "#36A2EB",
              "#FFCE56",
              "#4BC0C0",
            ],
          },
        ],
      });
    }
  }, [dashboarddata2]);


  useEffect(() => {
    if (dashboarddata2 && dashboarddata2.smsChartData?.length) {
      const labels = dashboarddata2.smsChartData.map((item) => item.label);
      const outboundData = dashboarddata2.smsChartData.map((item: any) =>
        parseInt(item.Outbound, 10)
      );
      const inboundData = dashboarddata2.smsChartData.map((item: any) =>
        parseInt(item.Inbound, 10)
      );

      setsmsChartData({
        labels,
        datasets: [
          {
            label: "Outgoing",
            data: outboundData,
            borderColor: "rgba(75,192,192,1)",
            backgroundColor: "rgba(75,192,192,0.2)",
            fill: true,
            tension: 0.1,
          },
          {
            label: "Incoming",
            data: inboundData,
            borderColor: "rgba(153,102,255,1)",
            backgroundColor: "rgba(153,102,255,0.2)",
            fill: true,
            tension: 0.1,
          },
        ],
      });
    }
  }, [dashboarddata2]);

  useEffect(() => {
    if (dashboarddata2 && dashboarddata2.smtpChartData?.length) {
      const labels = dashboarddata2.smtpChartData.map((item) => item.label);
      const outboundData = dashboarddata2.smtpChartData.map((item: any) =>
        parseInt(item.Outbound, 10)
      );

      setsmtpChartData({
        labels,
        datasets: [
          {
            label: "Outgoing",
            data: outboundData,
            borderColor: "rgba(75,192,192,1)",
            backgroundColor: "rgba(75,192,192,0.2)",
            fill: true,
            tension: 0.1,
          },
        ],
      });
    }
  }, [dashboarddata2]);


  useEffect(() => {
    dispatch(
      GetallSmsCampaign({
        search,
        page: currentPage,
        limit
      })
    );
  }, [dispatch, currentPage]);

  useEffect(() => {
    if (smscampaigndata) {
      const newOptions = smscampaigndata.map((item: any) => ({
        value: item.id,
        label: item.name,
      }));

      setSmscampaignOptions((prevOptions) => {
        // Combine old and new options while avoiding duplicates
        const existingIds = new Set(prevOptions.map((option) => option.value));
        const filteredNewOptions = newOptions.filter((option) => !existingIds.has(option.value));

        return [...prevOptions, ...filteredNewOptions];
      });
    }
  }, [smscampaigndata]);

  const loadMoreOptions = () => {
    if (currentPage < (info?.total_page || 0)) {
      setCurrentPage((prevPage) => prevPage + 1); // Increment the page
    }
  };

  const handleSearchChange = debounce((newSearch: string) => {
    setSearch(newSearch);
    setCurrentPage(1); // Reset to the first page
    dispatch(
      GetallSmsCampaign({
        search: newSearch,
        page: 1,
        limit,
      })
    );
  }, 1000); // Debounced function with a 500ms delay

  useEffect(() => {
    dispatch(
      GetallSmtpCampaign({
        search,
        page: currentPage,
        limit
      })
    );
  }, [dispatch, currentPage]);

  useEffect(() => {
    if (smtpcampaigndata) {
      const newOptions = smtpcampaigndata.map((item: any) => ({
        value: item.id,
        label: item.name,
      }));

      setSmtpcampaignOptions((prevOptions) => {
        // Combine old and new options while avoiding duplicates
        const existingIds = new Set(prevOptions.map((option) => option.value));
        const filteredNewOptions = newOptions.filter((option) => !existingIds.has(option.value));

        return [...prevOptions, ...filteredNewOptions];
      });
    }
  }, [smtpcampaigndata]);

  const handleSearchChangesmtp = debounce((newSearch: string) => {
    setSearch(newSearch);
    setCurrentPage(1); // Reset to the first page
    dispatch(
      GetallSmtpCampaign({
        search: newSearch,
        page: 1,
        limit,
      })
    );
  }, 1000); // Debounced function with a 500ms delay

  const [dateRange, setDateRange] = useState({
    from: "",
    to: "",
  });

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setDateRange((prev) => ({ ...prev, [name]: value }));
  };

  const formatDate = (date: string): string => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const applyDateFilter = () => {
    if (!dateRange.from || !dateRange.to) {
      return;
    }

    const formattedFrom = formatDate(dateRange.from);
    const formattedTo = formatDate(dateRange.to);

    setDateRangeText(`${formattedFrom} - ${formattedTo}`);

    dispatch(
      GetallDashboard2Data({
        from: formattedFrom,
        to: formattedTo,
        campaign_type: "",
        campaign_id: null,
      })
    );
  };


  const clearDateFilter = () => {
    setDateRange({ from: "", to: "" });
    setDateRangeText("Date Filter")

    dispatch(
      GetallDashboard2Data({
        from: "",
        to: "",
        campaign_type: "",
        campaign_id: null,
      })
    );
    setsmsChartData({ labels: [], datasets: [] });
    setsmtpChartData({ labels: [], datasets: [] });
  };

  const [chartOptions, setChartOptions] = useState<ChartOptions<"pie">>({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "right",
        labels: {
          font: {
            size: 14,
          },
          generateLabels: (chart: any) => {
            const data = chart.data;
            if (!data.labels || !data.datasets.length) return [];

            const total = data.datasets[0].data
              .filter((value: any): value is number => typeof value === "number")
              .reduce((sum: any, value: number) => sum + value, 0);

            return data.labels.map((label: any, index: number) => {
              const value = data.datasets[0].data[index] as number | undefined;
              if (value === undefined) return null;

              const percentage = ((value / total) * 100).toFixed(2);

              const backgroundColor = Array.isArray(data.datasets[0].backgroundColor)
                ? data.datasets[0].backgroundColor[index]
                : undefined;

              const borderColor = Array.isArray(data.datasets[0].borderColor)
                ? data.datasets[0].borderColor[index]
                : undefined;

              return {
                text: `${label}: ${percentage}%  value:${value}`,
                fillStyle: backgroundColor,
                strokeStyle: borderColor,
                hidden: !chart.getDataVisibility(index),
                index,
              };
            }).filter(Boolean);
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            const dataset = tooltipItem.dataset;
            const dataIndex = tooltipItem.dataIndex;
            const total = dataset.data.reduce(
              (sum: number, value: number) => sum + value,
              0
            );
            const currentValue = dataset.data[dataIndex];
            const percentage = ((currentValue / total) * 100).toFixed(2);
            const label = tooltipItem.chart.data.labels[dataIndex];

            return [`${label}: ${percentage}%`, `Value ${currentValue}`];
          },
        },
      },
    },
  });


  useEffect(() => {
    const updateLegendPosition = () => {
      const isMobile = window.matchMedia("(max-width: 992px)").matches;
      setChartOptions((prevOptions) => ({
        ...prevOptions,
        plugins: {
          ...prevOptions.plugins,
          legend: {
            ...prevOptions.plugins?.legend,
            position: isMobile ? "top" : "right",
          },
        },
      }));
    };

    // Initialize on component mount
    updateLegendPosition();

    // Add resize event listener
    window.addEventListener("resize", updateLegendPosition);

    // Cleanup event listener on unmount
    return () => window.removeEventListener("resize", updateLegendPosition);
  }, []);

  

  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-6">
                <h1 className="mb-sm-0 mb-2">Dashboard</h1>
              </div>

              <div className="col-sm-6">
                <div className="d-flex align-items-center justify-content-end">
                  <CreatableSelect
                    name="smscampaign"
                    options={smscampaignOptions}
                    isLoading={loading}
                    placeholder="SMS Campaign"
                    isClearable // Enables the clear button for single select
                    classNamePrefix="select"
                    className={`shadow-none dashboard-filter-width d-xl-block d-none`}
                    value={selectedSMSOption}
                    onInputChange={handleSearchChange}
                    onChange={(selectedOption: OptionType | null) => {
                      setSelectedSMSOption(selectedOption); // Update SMS dropdown selection
                      setSelectedSMTPOption(null); // Clear SMTP dropdown

                      if (selectedOption) {
                        dispatch(
                          GetallDashboard2Data({
                            from: dateRange.from,
                            to: dateRange.to,
                            campaign_type: "SMS",
                            campaign_id: selectedOption.value ?? null,
                          })
                        );
                        setShowSMSChart(true);
                        setShowSMTPChart(false);
                      } else {
                        dispatch(
                          GetallDashboard2Data({
                            from: dateRange.from,
                            to: dateRange.to,
                            campaign_type: "SMS",
                            campaign_id: null,
                          })
                        );
                        setShowSMSChart(true);
                        setShowSMTPChart(true);

                      }
                    }}
                    formatOptionLabel={(option: OptionType) => (
                      <div>
                        <p className="fw-semibold mb-0">{option.label}</p>
                      </div>
                    )}
                    components={{
                      MenuList: (props) => (
                        <>
                          {props.children}
                          {smscampaignOptions.length < (info?.count || 0) && (
                            <button
                              onClick={loadMoreOptions}
                              className="bg-primary border-light d-inline-block btn border-0"
                              style={{ width: "100%", padding: "5px", textAlign: "center" }}
                            >
                              Load More
                            </button>
                          )}
                        </>
                      ),
                    }}
                  />

                  <CreatableSelect
                    name="smtpcampaign"
                    options={smtpcampaignOptions}
                    isClearable
                    isLoading={loading}
                    placeholder="SMTP Campaign"
                    classNamePrefix="select"
                    className={`shadow-none dashboard-filter-width ms-2 d-xl-block d-none`}
                    value={selectedSMTPOption} // Controlled value for SMTP dropdown
                    onInputChange={handleSearchChangesmtp}
                    onChange={(selectedOption: OptionType | null) => {
                      setSelectedSMTPOption(selectedOption); // Update SMTP dropdown selection
                      setSelectedSMSOption(null); // Clear SMS dropdown

                      if (selectedOption) {
                        dispatch(
                          GetallDashboard2Data({
                            from: dateRange.from,
                            to: dateRange.to,
                            campaign_type: "SMTP",
                            campaign_id: selectedOption.value ?? null,
                          })
                        );
                        setShowSMTPChart(true);
                        setShowSMSChart(false);
                      } else {
                        setShowSMTPChart(true);
                        setShowSMSChart(true);
                      }
                    }}
                    formatOptionLabel={(option: OptionType) => (
                      <div>
                        <p className="fw-semibold mb-0">{option.label}</p>
                      </div>
                    )}
                    components={{
                      MenuList: (props) => (
                        <>
                          {props.children}
                          {smtpcampaignOptions.length < (info?.count || 0) && (
                            <button
                              onClick={loadMoreOptions}
                              className="bg-primary border-light d-inline-block btn border-0"
                              style={{ width: "100%", padding: "5px", textAlign: "center" }}
                            >
                              Load More
                            </button>
                          )}
                        </>
                      ),
                    }}
                  />

                  <Dropdown>
                    <Dropdown.Toggle
                      className="fw-semibold ms-3 mb-sm-0 mb-1"
                      variant="success"
                      id="dropdown-basic"
                    >
                      {dateRangeText}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="p-3 Date-Filter-Menu" style={{ width: "250px" }}>
                      <div className="d-flex flex-column">
                        <label className="mb-2 fw-semibold">From</label>
                        <input
                          type="date"
                          name="from"
                          value={dateRange.from}
                          onChange={handleDateChange}
                          className="form-control mb-3"
                        />

                        <label className="mb-2 fw-semibold">To</label>
                        <input
                          type="date"
                          name="to"
                          value={dateRange.to}
                          onChange={handleDateChange}
                          className="form-control mb-3"
                        />

                        <div className="d-flex justify-content-between">
                          <button className="btn btn-primary w-100 me-1" onClick={applyDateFilter}>
                            Apply
                          </button>

                          <button className="btn btn-secondary w-100 ms-1" onClick={clearDateFilter}>
                            Clear
                          </button>
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row align-i tems-center mt-3">
              <div className='col-6 pe-0'>
                <CreatableSelect
                  name="smscampaign"
                  options={smscampaignOptions}
                  isClearable
                  isLoading={loading}
                  placeholder="SMS Campaign"
                  classNamePrefix="select"
                  className={`shadow-none dashboard-filter-width d-xl-none`}
                  onInputChange={handleSearchChange}
                  onChange={(selectedOption: OptionType | null) => {
                    setSelectedSMSOption(selectedOption); // Update SMS dropdown selection
                    setSelectedSMTPOption(null); // Clear SMTP dropdown

                    if (selectedOption) {
                      dispatch(
                        GetallDashboard2Data({
                          from: dateRange.from,
                          to: dateRange.to,
                          campaign_type: "SMS",
                          campaign_id: selectedOption.value ?? null,
                        })
                      );
                      setShowSMSChart(true);
                      setShowSMTPChart(false);
                    } else {
                      dispatch(
                        GetallDashboard2Data({
                          from: dateRange.from,
                          to: dateRange.to,
                          campaign_type: "SMS",
                          campaign_id: null,
                        })
                      );
                      setShowSMSChart(true);
                      setShowSMTPChart(true);

                    }
                  }}
                  formatOptionLabel={(option: OptionType) => (
                    <div>
                      <p className="fw-semibold mb-0">{option.label}</p>
                    </div>
                  )}
                  components={{
                    MenuList: (props) => (
                      <>
                        {props.children}
                        {smscampaignOptions.length < (info?.count || 0) && (
                          <button
                            onClick={loadMoreOptions}
                            className="bg-primary border-light d-inline-block btn border-0"
                            style={{ width: "100%", padding: "5px", textAlign: "center" }}
                          >
                            Load More
                          </button>
                        )}
                      </>
                    ),
                  }}
                />
              </div>

              <div className='col-6'>
                <CreatableSelect
                  name="smtpcampaign"
                  options={smtpcampaignOptions}
                  isClearable
                  isLoading={loading}
                  placeholder="SMTP Campaign "
                  classNamePrefix="select"
                  className={`shadow-none dashboard-filter-width d-xl-none`}
                  onInputChange={handleSearchChangesmtp}
                  onChange={(selectedOption: OptionType | null) => {
                    setSelectedSMTPOption(selectedOption); // Update SMTP dropdown selection
                    setSelectedSMSOption(null); // Clear SMS dropdown

                    if (selectedOption) {
                      dispatch(
                        GetallDashboard2Data({
                          from: dateRange.from,
                          to: dateRange.to,
                          campaign_type: "SMTP",
                          campaign_id: selectedOption.value ?? null,
                        })
                      );
                      setShowSMTPChart(true);
                      setShowSMSChart(false);
                    } else {
                      setShowSMTPChart(true);
                      setShowSMSChart(true);
                    }
                  }}
                  formatOptionLabel={(option: OptionType) => (
                    <div>
                      <p className="fw-semibold mb-0">{option.label}</p>
                    </div>
                  )}
                  components={{
                    MenuList: (props) => (
                      <>
                        {props.children}
                        {smtpcampaignOptions.length < (info?.count || 0) && (
                          <button
                            onClick={loadMoreOptions}
                            className="bg-primary border-light d-inline-block btn border-0"
                            style={{ width: "100%", padding: "5px", textAlign: "center" }}
                          >
                            Load More
                          </button>
                        )}
                      </>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            {/* Chart Section Start */}
            <div className="row">
              {showSMSChart && (
                <div
                  className={`${showSMTPChart ? "col-xl-6" : "col-xl-6 d-none"
                    }`}
                >
                  <div className="card">
                    <div className="card-header bg-white d-flex align-items-center">
                      <h5 className="m-0 flex-grow-1">SMS traffic</h5>
                    </div>
                    <div className="card-body">
                      {smsChartData && smsChartData.datasets?.length > 0 ? (
                        <div className="responsive-charts">
                          <Line
                            data={smsChartData}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                            }}
                          />
                        </div>
                      ) : (
                        <p className="fw-semibold fs-5 text-center mb-0">No data found</p>
                      )}

                    </div>
                  </div>
                </div>
              )}

              {showSMTPChart && (
                <div
                  className={`${showSMSChart ? "col-xl-6" : "col-xl-6 d-none"
                    }`}
                >
                  <div className="card">
                    <div className="card-header bg-white d-flex align-items-center">
                      <h5 className="m-0 flex-grow-1">SMTP traffic</h5>
                    </div>
                    <div className="card-body">
                      {smtpChartData && smtpChartData.datasets.length > 0 ? (
                        <div className="responsive-charts">
                          <Line
                            data={smtpChartData}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                            }}
                          />
                        </div>
                      ) : (
                        <p className="fw-semibold fs-5 text-center mb-0">No data found</p>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* Chart Section End */}


            {/* =================pie-chart-start================ */}
            {/* ====sms-piechart-start*/}
            <div className="row">
              {showSMSChart && (
                <div
                  className={`${showSMTPChart ? "col-xl-6 d-none" : "col-xl-6"
                    }`}
                >
                  <div className="card">
                    <div className="card-header bg-white d-flex align-items-center">
                      <h5 className="m-0 flex-grow-1">SMS traffic</h5>
                    </div>
                    <div className="card-body">
                      {smsChartData && smsChartData.datasets?.length > 0 ? (
                        <div className="responsive-charts">
                          <Line
                            data={smsChartData}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                            }}
                          />
                        </div>
                      ) : (
                        <p className="fw-semibold fs-5 text-center mb-0">No data found</p>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {showSMSChart && (
                <div
                  className={`${showSMTPChart ? "col-xl-6" : "col-xl-6"
                    }`}
                >
                  <div className="card">
                    <div className="card-header bg-white d-flex align-items-center">
                      <h5 className="m-0 flex-grow-1">SMS Details</h5>
                    </div>
                    <div className="card-body">
                      {pieChartData.datasets.length &&
                        pieChartData.datasets[0].data.reduce((sum, value) => sum + value, 0) > 0 ? (
                        <div style={{ width: "100%", height: "400px" }}>
                          <Pie data={pieChartData} options={chartOptions} />
                        </div>
                      ) : (
                        <p className="text-center fs-5 fw-semibold mb-0">
                          No data found
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {/* ====sms-piechart-End*/}


              {/* ======smtp-piechart-Start====== */}
              {showSMTPChart && (
                <div
                  className={`${showSMSChart ? "col-xl-6 d-none" : "col-xl-6"
                    }`}
                >
                  <div className="card">
                    <div className="card-header bg-white d-flex align-items-center">
                      <h5 className="m-0 flex-grow-1">SMTP traffic</h5>
                    </div>
                    <div className="card-body">
                      {smtpChartData && smtpChartData.datasets.length > 0 ? (
                        <div className="responsive-charts">
                          <Line
                            data={smtpChartData}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                            }}
                          />
                        </div>
                      ) : (
                        <p className="fw-semibold fs-5 text-center mb-0">No data found</p>
                      )}
                    </div>
                  </div>

                </div>
              )}
              {showSMTPChart && (
                <div
                  className={`${showSMSChart ? "col-xl-6" : "col-xl-6"
                    }`}
                >
                  <div className="card">
                    <div className="card-header bg-white d-flex align-items-center">
                      <h5 className="m-0 flex-grow-1">SMTP Details</h5>
                    </div>
                    <div className="card-body">
                      {smtppieChartData.datasets.length &&
                        smtppieChartData.datasets[0].data.reduce((sum, value) => sum + value, 0) > 0 ? (
                        <div style={{ width: "100%", height: "400px" }}>
                          <Pie data={smtppieChartData} options={chartOptions} />
                        </div>
                      ) : (
                        <p className="text-center fw-semibold fs-5 mb-0">
                          No data found
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* ======smtp-piechart-End====== */}
            {/* =====================pie-chart-end======================= */}

            {/* SMS Campaigns Section */}
            <div className="card mt-3">
              <div className="card-header bg-white p-3">
                <h2 className="fs-5 mb-0">SMS Campaigns</h2>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-hover mb-0 table-bordered text-nowrap">
                    <thead>
                      <tr>
                        <th className="ps-3 sr-no">SR No</th>
                        <th style={{ minWidth: 200 }}>Name</th>
                        <th className="text-center createdat">Created At</th>
                        <th className="text-center action">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dashboarddata2?.smsCampaign?.length ? (
                        dashboarddata2.smsCampaign.map((campaign, index) => (
                          <tr key={campaign.id}>
                            <td className="ps-3">{index + 1}</td>
                            <td>{campaign.name}</td>
                            <td className="text-center">
                              {formatDate(campaign.createdAt)}
                            </td>
                            <td className="text-center">
                              <Link
                                to={`/admin/sms-campaigns/view/${campaign.id}/details/`}
                              >
                                <button className="ms-1 bg-transparent border-0 text-success fs-5">
                                  <i data-tooltip-id={"SMS_Campaigns_View_" + index} className="fa-solid fa-eye"></i>
                                  <HelpText id={"SMS_Campaigns_View_" + index} content="View SMS Campaign" />
                                </button>
                              </Link>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={4}
                            className="text-center fs-5 fw-semibold mb-0"
                          >
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* SMTP Campaigns Section */}
            <div className="card mt-4">
              <div className="card-header bg-white p-3">
                <h2 className="fs-5 mb-0">SMTP Campaigns</h2>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-hover mb-0 table-bordered text-nowrap">
                    <thead>
                      <tr>
                        <th className="ps-3 sr-no">SR No</th>
                        <th style={{ minWidth: 200 }}>Name</th>
                        <th className="text-center status">Status</th>
                        <th className="text-center createdat">Created At</th>
                        <th className="text-center action">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dashboarddata2?.smtpCampaign?.length ? (
                        dashboarddata2.smtpCampaign.map((item, index) => (
                          <tr key={item.id}>
                            <td className="ps-3">{index + 1}</td>
                            <td>{item.name}</td>
                            <td
                              className={`text-center ${item?.status === 1
                                ? "text-warning fw-bold"
                                : item?.status === 2
                                  ? "text-success fw-bold"
                                  : item?.status === 3
                                    ? "text-danger fw-bold"
                                    : item?.status === 4
                                      ? "text-success fw-bold"
                                      : item?.status === 5
                                        ? "text-danger fw-bold"
                                        : "text-danger"
                                }`}
                            >
                              {item.status === 1
                                ? "Pending"
                                : item.status === 2
                                  ? "Running"
                                  : item.status === 3
                                    ? "Stopped"
                                    : item.status === 4
                                      ? "Completed"
                                      : item.status === 5
                                        ? "Canceled"
                                        : "Failed"}
                            </td>
                            <td className="text-center">
                              {formatDate(item.createdAt)}
                            </td>
                            <td className="text-center">
                              <Link
                                to={`/admin/smtp-campaigns/view/${item.id}`}
                              >
                                <button className="ms-1 bg-transparent border-0 text-success fs-5">
                                  <i data-tooltip-id={"SMTP_Campaigns_View_" + index} className="fa-solid fa-eye"></i>
                                  <HelpText id={"SMTP_Campaigns_View_" + index} content="View SMTP Campaign" />
                                </button>
                              </Link>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={5}
                            className="text-center fs-5 fw-semibold"
                          >
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div >
    </div >
  );
}

export default Home;
